import { ToDateTimeText, ToDateFullMonthText } from "../../../utils/date";
import Box from "@material-ui/core/Box";
import Alarm from '@material-ui/icons/Alarm';
import Link from '@material-ui/core/Link';
import CloudDownloadIcon from '@material-ui/icons/CloudDownload';

export const getColumns = (ViewHistory) => {
  const columns = [
    {
      dataField: "USER_ID",
      text: "User ID",
      sort: true,
      headerAlign: 'center',
      formatter: (cell, row) => {
        return (
          <Link
            component="button"
            variant="body2"
            onClick={() => {
              ViewHistory(row.USER_ID,row.APP_ID);
            }}
          >
            {row.USER_ID}
          </Link>
        )

      }
    },
    {
      dataField: "PERMISSION",
      text: "Permission",
      sort: true,
      headerAlign: 'center',
      align: 'Left',
      
    },
    {
      dataField: "SPI_GROUP_NAME",
      text: "SPI Purpose",
      sort: true,
      headerAlign: 'center',
      align: 'center',
     
    },
    {
      dataField: "APP_NAME",
      text: "Application",
      sort: true,
      headerAlign: 'center',
      align: 'center',
     
    },
    {
      dataField: "UPDATE_DATE",
      text: "Last Update Time",
      sort: true,
      headerAlign: 'center',
      align: 'center',
      formatter: (cell, row, rowIndex) => {
        return <>{ToDateTimeText(row.UPDATE_DATE)}</>;
      },
    },
    {
      dataField: "UPDATE_BY",
      text: "Update By",
      sort: true,
      headerAlign: 'center',
      align: 'center',
    },
  ]
  return columns;
};
export const getHistoryColumns = () => {
  const columns = [
    {
      dataField: "ACTION",
      text: "Action",
      sort: false,
      headerStyle: (colum, colIndex) => {
        return { minWidth: '150px' , textAlign: 'center' };
      },
      align: 'center',
    },
    {
      dataField: "MESSAGE",
      text: "Item",
      sort: false,
      headerStyle: (colum, colIndex) => {
        return { minWidth: '300px' , textAlign: 'center' };
      },
      align: 'left',
    },
    {
      dataField: "REMARK",
      text: "Remark",
      sort: false,
      headerStyle: (colum, colIndex) => {
        return { minWidth: '300px' , textAlign: 'center' };
      },
      align: 'left',
    },
    {
      dataField: "UPDATE_BY",
      text: "Update By",
      sort: false,
      headerAlign: 'center',
      align: 'center',
    },
    {
      dataField: "UPDATE_DATE",
      text: "Update Date",
      sort: true,
      headerAlign: 'center',
      align: 'center',
      formatter: (cell, row, rowIndex) => {
        return <>{ToDateTimeText(row.UPDATE_DATE)}</>;
      },
    },

  ];
  return columns;
};